import { Component, OnInit, Input, Output, EventEmitter, HostListener, ElementRef } from '@angular/core';
import { VehicleFilter } from '../../../models/vehicles/vehicleFilter';

@Component({
  selector: 'vehicle-filter',
  templateUrl: './vehicle-filter.component.html',
  styleUrls: ['./vehicle-filter.component.css']
})
export class VehicleFilterComponent implements OnInit {

	showFilter: boolean = false;
	
	@Input() filter: VehicleFilter = new VehicleFilter();
	@Output() search: EventEmitter<VehicleFilter> = new EventEmitter<VehicleFilter>()
	
	@HostListener('document:click', ['$event'])
	clickout(event) {
		if (!this._elementRef.nativeElement.contains(event.target))
			this.showFilter = false;
	}

	constructor(private _elementRef: ElementRef,) { }

	ngOnInit() {
	}

	toggleFilter() {
		this.showFilter = !this.showFilter;
	}

	onSearchClick() {
		this.search.emit(this.filter);
		this.showFilter = false;
	}

	onClearClick() {
		this.filter.plateNumber = null;
		this.filter.isTruck = null;
	}
}



// WEBPACK FOOTER //
// ./src/app/components/vehicles/vehicle-filter/vehicle-filter.component.ts